<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"MENUITEMS.IMPNOTICE.NOTICE" | translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column justify-content-center">
    <!-- <div class="flex-grow-1 white-bg d-flex align-items-center justify-content-center spinner-overlay" *ngIf="isSpinnerLoading">
      <div class="custom-loader"></div>
    </div> -->
    <form action="" [formGroup]="noticeForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6 mt-3 mt-3 mt-lg-4">
          <label for=""> {{"COMMON.TITLE"|translate}}</label>
          <div class="form-input">
            <input type="text" class="form-control"
              placeholder="{{'COMMON.ENTER'|translate}} {{'COMMON.TITLE'|translate}}" formControlName="tit">
          </div>
          <mat-error *ngIf="isControlHasError('tit','required')"> {{"This is required"|translate}}</mat-error>
        </div>
        <div class="col-md-6 mt-3 mt-lg-4">
          <label for=""> {{"COMMON.DEP"|translate}}</label>
          <!-- <mat-select multiple formControlName="d_i" class="form-control" placeholder="Select Department">
                    <mat-option value="0" selected="true">{{ "All" | translate}}</mat-option>
                    <mat-option *ngFor="let data of departmentData" [value]="data.company_d_i">{{ data.department_name }}</mat-option>
                </mat-select> -->
          <ng-multiselect-dropdown (onSelect)="onSchemesChanged(false)"
            (onDeSelect)="onSchemesChanged(true)" (onSelectAll)="onSchemesChanged(false)"
            (onDeSelectAll)="onSchemesChanged(true)" formControlName="d_i" [settings]="dropdownSettings"
            [data]="departmentData"> </ng-multiselect-dropdown>
          <mat-error *ngIf="isControlHasError('d_i','required') || showDepError"> {{"COMMON.THR"|translate}}
          </mat-error>
        </div>
      </div>
      <div class="mt-3">
        <div><label for="">{{"COMMON.DESC"|translate}}</label></div>
        <quill-editor [styles]="{width: '100%',height:'120px'}" class="d-block" formControlName="desc"></quill-editor>
        <mat-error *ngIf="isControlHasError('desc','required')"> {{"COMMON.THR"|translate}}</mat-error>
      </div>
      <div class="row">
        <div class="col-md-6 mt-3 mt-3 mt-lg-4">
          <label for=""> {{"COMMON.STARTDATE"|translate}}</label>
          <div class="in-box">
            <!-- <input class="form-control" [matDatepicker]="startDate"  formControlName="st_dt" [min]="minDate"/> -->
            <input class="form-control" [matDatepicker]="startDate" formControlName="st_dt" [min]="minDate" readonly />
            <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
          </div>
          <mat-error *ngIf="isControlHasError('st_dt','required')"> {{"COMMON.THR"|translate}}</mat-error>
        </div>
        <div class="col-md-6 mt-3 mt-lg-4">
          <label for="">{{"COMMON.ENDDATE"|translate}}</label>
          <div class="in-box">
            <input class="form-control" [matDatepicker]="endDate" formControlName="ed_dt" [min]="noticeForm.value.st_dt"
              readonly />
            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
          </div>
          <mat-error *ngIf="isControlHasError('ed_dt','required')"> {{"COMMON.THR"|translate}} </mat-error>
          <mat-error *ngIf="noticeForm.hasError('startDtBeforeEndDt')"> {{"VALIDATION.EDBFST"|translate}} </mat-error>
          <!-- <mat-error *ngIf="isControlHasError('ed_dt','min')">  {{"Please select valid date"|translate}} </mat-error> -->
          <!-- <mat-error *ngIf="isControlHasError('end _date','dateNotBeforeToday')">  {{"Please select valid date"|translate}} </mat-error> -->
          <!-- <mat-error *ngIf="isControlHasError('ed_dt','required')">  {{"This is required"|translate}} </mat-error> -->
        </div>
      </div>
    </form>
  </div>
  <div class="row">
    <div class="col-md-6 m-auto">
      <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit()">{{
        "BUTTON.SAVE" | translate }}</button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>